export default __webpack_public_path__ + "images/Sagittal_View_of_Cervix_with_Placenta.3660837d4067db01cfcedc0e9fe6e743.png";